import * as React from 'react';
import { LoginSignupButtons, ProfileDropdown } from '@cx-web/components/composites';
import LoggedInMiniMyOC from '@cx-web/components/composites/MiniMyOC';
import { type ILabelActions } from '@cx-web/feature-i18n';

import { type Repub } from '@cx-modules/constants';

import styles from './MiniMyOC.module.css';

interface IProps {
  isLoggedIn: boolean;
  isUkStyle?: boolean;
  labelActions: ILabelActions;
  onLogout?: () => void;
  // Open the auth modal (NGF-6371): the auth-modal store opener bound to login/signup by the parent.
  onSignIn?: () => void;
  onSignUp?: () => void;
  repub?: Repub;
  showProfileLink?: boolean;
  siteConfig?: { subscriptions?: { enabled?: boolean } };
  styles?: string;
  type: 'desktop' | 'burgerTop' | 'pageButton';
}

class MiniMyOC extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps): boolean {
    return (
      nextProps.type !== this.props.type ||
      nextProps.isLoggedIn !== this.props.isLoggedIn ||
      nextProps.isUkStyle !== this.props.isUkStyle ||
      nextProps.repub !== this.props.repub ||
      // Callbacks forwarded to the UK components (ProfileDropdown/LoginSignupButtons) via {...this.props}:
      // tracked so a changed handler reference can't go stale behind this SCU.
      nextProps.onLogout !== this.props.onLogout ||
      nextProps.onSignIn !== this.props.onSignIn ||
      nextProps.onSignUp !== this.props.onSignUp ||
      nextProps.showProfileLink !== this.props.showProfileLink ||
      nextProps.siteConfig?.subscriptions?.enabled !== this.props.siteConfig?.subscriptions?.enabled
    );
  }

  private renderDesktop = (): React.JSX.Element | null => {
    const { isLoggedIn, isUkStyle, labelActions, onSignIn } = this.props;

    // Atlas is merging styles with UK Header
    if (isUkStyle) {
      return isLoggedIn ? <ProfileDropdown {...this.props} /> : <LoginSignupButtons {...this.props} />;
    }

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    return (
      <button
        className={[styles.miniOCButtonDesktopAndTablet, styles.login].join(' ')}
        id="loginLabel"
        onClick={onSignIn}
        type="button"
      >
        {labelActions.get('SIGN_IN')}
      </button>
    );
  };

  private renderBurgerTop = (): React.JSX.Element | null => {
    const { isLoggedIn, labelActions, onSignIn } = this.props;

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    return (
      <button
        className={[styles.miniOCButton, styles.login].join(' ')}
        id="loginLabel"
        onClick={onSignIn}
        type="button"
      >
        {labelActions.get('SIGN_IN')}
      </button>
    );
  };

  private renderPageButtonItem = (): React.JSX.Element => {
    const { isLoggedIn, labelActions, onSignUp } = this.props;

    if (isLoggedIn) {
      return <LoggedInMiniMyOC {...this.props} />;
    }

    return (
      <div className={styles.loginButton}>
        <button onClick={onSignUp} type="button">
          {labelActions.get('SIGN_UP')}
        </button>
      </div>
    );
  };

  public render = (): React.JSX.Element | null => {
    switch (this.props.type) {
      case 'desktop':
        return this.renderDesktop();
      case 'burgerTop':
        return this.renderBurgerTop();
      case 'pageButton':
        return this.renderPageButtonItem();
      default:
        return null;
    }
  };
}

export default MiniMyOC;
